export const FixedPricingFeatures = [
	{
		label: "Set up",
		id: "setup",
		enabled: true,
		fee: 0,
		per: ""
	},
	{
		label: "Face to Face Counselling",
		id: "face-counselling",
		enabled: true,
		fee: 0,
		per: ""
	},
	{
		label: "Coaching Sessions",
		id: "coaching-sessions",
		enabled: true,
		fee: 0,
		per: ""
	},
	{
		label: "Therapy Sessions",
		id: "therapy-sessions",
		enabled: true,
		fee: 0,
		per: ""
	},
	// {
	// 	label: "Manager Support",
	// 	name: "managerSupport",
	// 	enabled: true,
	// 	fee: 0,
	// 	per: ""
	// },
	// {
	// 	label: "Mental Health Training",
	// 	name: "mentalHelthTraining",
	// 	enabled: true,
	// 	fee: 0,
	// 	per: ""
	// },
	{
		label: "Risk Callback",
		id: "risk-callback",
		enabled: true,
		fee: 0,
		per: ""
	},
	{
		label: "Phone and Video CIR",
		id: "phone-video-cir",
		enabled: true,
		fee: 0,
		per: ""
	},
	{
		label: "On-Site CIR",
		id: "onsite-cir",
		enabled: true,
		fee: 0,
		per: ""
	},
	{
		label: "On-Site Training & Workshops",
		id: "onsite-training-workshop",
		enabled: true,
		fee: 0,
		per: ""
	},
	{
		label: "Family Entitlement",
		id: "family-entitlement",
		enabled: true,
		fee: 0,
		per: ""
	},
	{
		label: "Care Navigator",
		id: "care-navigator",
		enabled: false,
		fee: 0,
		per: ""
	},
	{
		label: "Additonal Session Request",
		id: "additional-sessions",
		enabled: false,
		fee: 0,
		per: ""
	}
]

export const companyIndustry = [
	{
		label: "Accounting",
		value: "accounting"
	},
	{
		label: "Administration & Office Support",
		value: "Administration & Office Support"
	},
	{
		label: "Advertising, Arts & Media",
		value: "Advertising, Arts & Media"
	},
	{
		label: "Banking & Financial Services",
		value: "Banking & Financial Services"
	},
	{
		label: "Call Centre & Customer Service",
		value: "Call Centre & Customer Service"
	},
	{
		label: "Community Services & Development",
		value: "Community Services & Development"
	},
	{
		label: "Construction",
		value: "Construction"
	},
	{
		label: "Consulting & Strategy",
		value: "Consulting & Strategy"
	},
	{
		label: "Design & Architecture",
		value: "Design & Architecture"
	},
	{
		label: "Education & Training",
		value: "Education & Training"
	},
	{
		label: "Engineering",
		value: "Engineering"
	},
	{
		label: "Farming, Animals & Conservation",
		value: "Farming, Animals & Conservation"
	},
	{
		label: "Government & Defence",
		value: "Government & Defence"
	},
	{
		label: "Healthcare & Medical",
		value: "Healthcare & Medical"
	},
	{
		label: "Hospitality & Tourism",
		value: "Hospitality & Tourism"
	},
	{
		label: "Human Resources & Recruitment",
		value: "Human Resources & Recruitment"
	},
	{
		label: "Information & Communication Technology",
		value: "Information & Communication Technology"
	},
	{
		label: "Insurance & Superannuation",
		value: "Insurance & Superannuation"
	},
	{
		label: "Legal",
		value: "Legal"
	},
	{
		label: "Manufacturing, Transport & Logistics",
		value: "Manufacturing, Transport & Logistics"
	},
	{
		label: "Marketing & Communications",
		value: "Marketing & Communications"
	},
	{
		label: "Mining, Resources and Energy",
		value: "Mining, Resources and Energy"
	},
	{
		label: "Real Estate & Property",
		value: "Real Estate & Property"
	},
	{
		label: "Retail & Consumer Products",
		value: "Retail & Consumer Products"
	},
	{
		label: "Sales",
		value: "Sales"
	},
	{
		label: "Science & Technology",
		value: "Science & Technology"
	},
	{
		label: "Sport & Recreation",
		value: "Sport & Recreation"
	},
	{
		label: "Trades & Services",
		value: "Trades & Services"
	},
	{
		label: "Not-for-Profit",
		value: "Not-for-Profit"
	}
]

export const accountManager = [
	{
		label: "Reine Salonga",
		value: "Reine Salonga"
	},
	{
		label: "Teresa Chavez",
		value: "Teresa Chavez"
	},
	{
		label: "Gaby Ramos",
		value: "Gaby Ramos"
	},
	{
		label: "Anahi Ramos",
		value: "Anahi Ramos"
	},
	{
		label: "Ops Team",
		value: "Ops Team"
	},
	{
		label: "Other",
		value: "Other"
	}
]

export const salesManager = [
	{
		label: "Eddy Tam",
		value: "Eddy Tam"
	},
	{
		label: "Nayeli Brancaccio",
		value: "Nayeli Brancaccio"
	}
]

export const australianStates = [
	{
		label: "New South Wales",
		value: "New South Wales",
		abbreviation: "nsw",
		capital: "sydney",
		type: "state"
	},
	{
		label: "Northern Territory",
		value: "Northern Territory",
		abbreviation: "nt",
		capital: "darwin",
		type: "territory"
	},
	{
		label: "Queensland",
		value: "Queensland",
		abbreviation: "qld",
		capital: "brisbane",
		type: "state"
	},
	{
		label: "South Australia",
		value: "South Australia",
		abbreviation: "sa",
		capital: "adelaide",
		type: "state"
	},
	{
		label: "Tasmania",
		value: "Tasmania",
		abbreviation: "tas",
		capital: "hobart",
		type: "state"
	},
	{
		label: "Victoria",
		value: "Victoria",
		abbreviation: "vic",
		capital: "melbourne",
		type: "state"
	},
	{
		label: "Western Australia",
		value: "Western Australia",
		abbreviation: "wa",
		capital: "perth",
		type: "state"
	}
]

export const cancelReason = {
	inTime: "More than 24 hours notice",
	within24: "Within 24 hours of booking",
	userNoShow: "User no show",
	in_time: "More than 24 hours notice",
	within_24: "Within 24 hours of booking",
	user_no_show: "User no show",
	user_cancelled: "User cancelled"
}

export const cancelStatus = {
	user_cancelled: "User cancelled",
	coach_cancelled: "Coach Cancelled"
}

export const userType = [
	{
		label: "Coach Guided",
		value: "coachGuided"
	},
	{
		label: "User Guided",
		value: "userGuided"
	}
]

export const USStates = [
	{
		label: "Alabama",
		value: "AL"
	},
	{
		label: "Alaska",
		value: "AK"
	},
	{
		label: "American Samoa",
		value: "AS"
	},
	{
		label: "Arizona",
		value: "AZ"
	},
	{
		label: "Arkansas",
		value: "AR"
	},
	{
		label: "California",
		value: "CA"
	},
	{
		label: "Colorado",
		value: "CO"
	},
	{
		label: "Connecticut",
		value: "CT"
	},
	{
		label: "Delaware",
		value: "DE"
	},
	{
		label: "District Of Columbia",
		value: "DC"
	},
	{
		label: "Federated States Of Micronesia",
		value: "FM"
	},
	{
		label: "Florida",
		value: "FL"
	},
	{
		label: "Georgia",
		value: "GA"
	},
	{
		label: "Guam",
		value: "GU"
	},
	{
		label: "Hawaii",
		value: "HI"
	},
	{
		label: "Idaho",
		value: "ID"
	},
	{
		label: "Illinois",
		value: "IL"
	},
	{
		label: "Indiana",
		value: "IN"
	},
	{
		label: "Iowa",
		value: "IA"
	},
	{
		label: "Kansas",
		value: "KS"
	},
	{
		label: "Kentucky",
		value: "KY"
	},
	{
		label: "Louisiana",
		value: "LA"
	},
	{
		label: "Maine",
		value: "ME"
	},
	{
		label: "Marshall Islands",
		value: "MH"
	},
	{
		label: "Maryland",
		value: "MD"
	},
	{
		label: "Massachusetts",
		value: "MA"
	},
	{
		label: "Michigan",
		value: "MI"
	},
	{
		label: "Minnesota",
		value: "MN"
	},
	{
		label: "Mississippi",
		value: "MS"
	},
	{
		label: "Missouri",
		value: "MO"
	},
	{
		label: "Montana",
		value: "MT"
	},
	{
		label: "Nebraska",
		value: "NE"
	},
	{
		label: "Nevada",
		value: "NV"
	},
	{
		label: "New Hampshire",
		value: "NH"
	},
	{
		label: "New Jersey",
		value: "NJ"
	},
	{
		label: "New Mexico",
		value: "NM"
	},
	{
		label: "New York",
		value: "NY"
	},
	{
		label: "North Carolina",
		value: "NC"
	},
	{
		label: "North Dakota",
		value: "ND"
	},
	{
		label: "Northern Mariana Islands",
		value: "MP"
	},
	{
		label: "Ohio",
		value: "OH"
	},
	{
		label: "Oklahoma",
		value: "OK"
	},
	{
		label: "Oregon",
		value: "OR"
	},
	{
		label: "Palau",
		value: "PW"
	},
	{
		label: "Pennsylvania",
		value: "PA"
	},
	{
		label: "Puerto Rico",
		value: "PR"
	},
	{
		label: "Rhode Island",
		value: "RI"
	},
	{
		label: "South Carolina",
		value: "SC"
	},
	{
		label: "South Dakota",
		value: "SD"
	},
	{
		label: "Tennessee",
		value: "TN"
	},
	{
		label: "Texas",
		value: "TX"
	},
	{
		label: "Utah",
		value: "UT"
	},
	{
		label: "Vermont",
		value: "VT"
	},
	{
		label: "Virgin Islands",
		value: "VI"
	},
	{
		label: "Virginia",
		value: "VA"
	},
	{
		label: "Washington",
		value: "WA"
	},
	{
		label: "West Virginia",
		value: "WV"
	},
	{
		label: "Wisconsin",
		value: "WI"
	},
	{
		label: "Wyoming",
		value: "WY"
	}
]
